import {SeoError} from './SeoError.js'

export class MakeModelFaqsRequestError extends SeoError {}
